import { ExclamationCircleIcon, CheckCircleIcon, ExclamationOctagonIcon, ExclamationTriangleIcon } from '@koaly/koaly-ui-icons';
import { spaceProp, getFontTokenStyle, getVariantToken, getSizeToken } from '@koaly/mixins';
import React from 'react';
import styled from 'styled-components';
import { List } from '../List/List.js';
import { ListItem } from '../List/ListItem.js';

const StyledStatusMessages = styled.div `
  ${({ spaceAfter }) => spaceAfter && spaceProp(spaceAfter, 'marginBottom')};
  ${({ spaceAfter }) => spaceAfter && spaceProp(spaceAfter, 'marginTop')};
`;
const StyledStatusMessage = styled.p `
  /* reset */
  margin: 0;
  ${getFontTokenStyle('label', 'medium')};
  color: ${({ type }) => getVariantToken('statusMessages', 'color', type)};

  svg {
    position: relative;
    top: 3px;
    width: ${getSizeToken('statusMessages', 'iconSize')};
    height: ${getSizeToken('statusMessages', 'iconSize')};
  }
`;
const StatusMessage = ({ type, iconOverride, children }) => {
    const statusIcons = {
        'danger': ExclamationCircleIcon,
        'success': CheckCircleIcon,
        'info': ExclamationOctagonIcon,
        'warning': ExclamationTriangleIcon,
    };
    const Icon = iconOverride ? iconOverride : statusIcons[type];
    return (React.createElement(StyledStatusMessage, { type: type },
        React.createElement(Icon, null),
        " ",
        children));
};
const StatusMessages = ({ items, type, className, iconOverride, id, }) => {
    return (React.createElement(StyledStatusMessages, { id: id, className: className }, typeof items === 'string' ? (React.createElement(StatusMessage, { iconOverride: iconOverride, type: type }, items)) : (React.createElement(List, null, items.map((item, key) => (React.createElement(ListItem, { key: key },
        React.createElement(StatusMessage, { iconOverride: iconOverride, type: type }, item))))))));
};

export { StatusMessage, StatusMessages };
//# sourceMappingURL=StatusMessages.js.map
